<template>
    <button
        v-tippy="t('editorSinkListItem')"
        :class="[
            buttonState(
                editor.can().sinkListItem('listItem') &&
                    (editor.isActive('orderedList') || editor.isActive('bulletList')),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().sinkListItem('listItem')"
        @click="editor.chain().focus().sinkListItem('listItem').run()"
    >
        <MdiFormatIndentIncrease class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatIndentIncrease from 'materialdesignicons-vue3/icons/MdiFormatIndentIncrease.js';

    defineExpose({
        name: 'IndentIncreaseButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
